import { DRSettings } from "./DRSettings";

export class Ratings {
  enabled: boolean = true;
  maxSRGain: number = 10;
  drSettings: DRSettings = new DRSettings();
}